'use client';

import React from 'react';

import { FavouritesProvider } from '@/context/FavouritesContext';
import { UserProvider } from './UserProvider';
import { ProfileSliderProvider } from './ProfileSliderProvider';
import { NinetailedExperienceProvider } from './ninetailed/ninetailed-provider';

export default function ClientProviders({
  children,
  mpId,
  locale,
  config,
}: {
  children: React.ReactNode;
  mpId?: string;
  locale?: string;
  config?: any;
}) {
  return (
    <UserProvider>
      <ProfileSliderProvider
        node_locale={locale}
        brandId={mpId}
        config={config}
      >
        <FavouritesProvider mpId={mpId} locale={locale} config={config}>
          <NinetailedExperienceProvider>
            {children}
          </NinetailedExperienceProvider>
        </FavouritesProvider>
      </ProfileSliderProvider>
    </UserProvider>
  );
}
